import axios from 'axios';

import { DataAnalysis } from '../types';

export const findChatDataAnalysis = (brandId: number, kind: string) =>
  axios.get<DataAnalysis>(
    `/api/brands/${brandId}/indicator_data/private_jump_data/${kind}`
  );
